<div *ngIf="showLoader" class="overlay d-flex justify-content-center">
  <div class="loader" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
